/* tslint:disable */
/* eslint-disable */
/**
 * fantasy-dynasty-app
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { TeamBudgetReport } from '../model';
/**
 * ReportingApi - axios parameter creator
 * @export
 */
export const ReportingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Generate an email report detailing the activities in the league over the previous week
         * @param {string} [leagueId] A unique identifier for a league
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWeeklyReport: async (leagueId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/league/{leagueId}/weeklyReport`
                .replace(`{${"leagueId"}}`, encodeURIComponent(String(leagueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retreives a report of the salary usage for all teams in the league
         * @param {string} [leagueId] A unique identifier for a league
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeagueBudgetReport: async (leagueId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/budgetReport/{leagueId}`
                .replace(`{${"leagueId"}}`, encodeURIComponent(String(leagueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportingApi - functional programming interface
 * @export
 */
export const ReportingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Generate an email report detailing the activities in the league over the previous week
         * @param {string} [leagueId] A unique identifier for a league
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateWeeklyReport(leagueId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateWeeklyReport(leagueId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retreives a report of the salary usage for all teams in the league
         * @param {string} [leagueId] A unique identifier for a league
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLeagueBudgetReport(leagueId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TeamBudgetReport>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLeagueBudgetReport(leagueId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReportingApi - factory interface
 * @export
 */
export const ReportingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportingApiFp(configuration)
    return {
        /**
         * 
         * @summary Generate an email report detailing the activities in the league over the previous week
         * @param {string} [leagueId] A unique identifier for a league
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWeeklyReport(leagueId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.generateWeeklyReport(leagueId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retreives a report of the salary usage for all teams in the league
         * @param {string} [leagueId] A unique identifier for a league
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeagueBudgetReport(leagueId?: string, options?: any): AxiosPromise<Array<TeamBudgetReport>> {
            return localVarFp.getLeagueBudgetReport(leagueId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportingApi - object-oriented interface
 * @export
 * @class ReportingApi
 * @extends {BaseAPI}
 */
export class ReportingApi extends BaseAPI {
    /**
     * 
     * @summary Generate an email report detailing the activities in the league over the previous week
     * @param {string} [leagueId] A unique identifier for a league
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public generateWeeklyReport(leagueId?: string, options?: AxiosRequestConfig) {
        return ReportingApiFp(this.configuration).generateWeeklyReport(leagueId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retreives a report of the salary usage for all teams in the league
     * @param {string} [leagueId] A unique identifier for a league
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public getLeagueBudgetReport(leagueId?: string, options?: AxiosRequestConfig) {
        return ReportingApiFp(this.configuration).getLeagueBudgetReport(leagueId, options).then((request) => request(this.axios, this.basePath));
    }
}
